import { notifications } from "@edgetier/global-components";
import { useFlags } from "hooks-for/feature-flags";
import { FunctionComponent, memo, useEffect, useState } from "react";
import { FEATURE_FLAGS } from "types-for/feature-flags";
import { useUpdateChecker } from "./use-update-checker";
import {
    UPDATE_AVAILABLE_INTERVAL_MS,
    UPDATE_AVAILABLE_NOTIFICATION_ID,
    UPDATE_AVAILABLE_NOTIFICATION_MESSAGE,
    UPDATE_AVAILABLE_NOTIFICATION_TITLE,
} from "./update-checker.constants";

/**
 * Poll for new deployments while the `update_checker` feature flag is enabled and, once one is
 * detected, show a persistent notification prompting the user to refresh the page.
 */
const UpdateChecker: FunctionComponent = () => {
    const flags = useFlags([FEATURE_FLAGS.UpdateChecker]);
    const isEnabled = flags[FEATURE_FLAGS.UpdateChecker].enabled;
    const [isUpdateAvailable, setIsUpdateAvailable] = useState(false);

    useUpdateChecker({
        intervalMs: UPDATE_AVAILABLE_INTERVAL_MS,
        onUpdateAvailable: () => setIsUpdateAvailable(true),
        enabled: isEnabled && !isUpdateAvailable,
    });

    useEffect(() => {
        if (!isEnabled || !isUpdateAvailable) return;

        notifications.warning({
            id: UPDATE_AVAILABLE_NOTIFICATION_ID,
            title: UPDATE_AVAILABLE_NOTIFICATION_TITLE,
            message: UPDATE_AVAILABLE_NOTIFICATION_MESSAGE,
            withCloseButton: true,
            autoClose: false,
        });
    }, [isEnabled, isUpdateAvailable]);

    return null;
};

export default memo(UpdateChecker);
